import request from "@/http/request"
import {
  queryAllNotice,
  selectNoticeById,
  selectNoticeList,
  updateShowStatus
} from '@/http/api'

export const queryAllNoticeInfo = () => {
    return request({
        url: queryAllNotice,
        method : "POST"
    })
}

export const selectNoticeByIdInfo = (data) => {
  return request({
      url: selectNoticeById,
      method : "POST",
      data
  })
}
export const selectNoticeListInfo = (data) => {
  return request({
      url: selectNoticeList,
      method : "POST",
      data
  })
}
export const updateShowStatusInfo = (data) => {
  return request({
      url: updateShowStatus,
      method : "POST",
      data
  })
}
